export default __webpack_public_path__ + "static-front/media/TubeIcon.54d04b10.svg";